import React, {useEffect, useMemo, useState} from 'react';
import AppText from "../../../../../common/AppText";
import {GlobalStyleAttributes, WebGlobalStyles} from "../../../../../../styles/GlobalStyles";
import {isRTL, t} from "../../../../../../services/i18n";
import moment from "moment";
import {dbDateFormat, dbTimeFormat, isMobile, sendDataEvent} from "../../../../../../services/Helpers";
import {fetchApi} from "../../../../../../services/HTTP";
import {Colors} from "../../../../../../styles/Colors";
import {useDispatch, useSelector} from "react-redux";
import {ActivityIndicator} from "react-native";
import {updateSummary, updateTempSelection} from "../../../../../../redux/stepperSlice";
import SharedTimepicker from "../../../../../common/SharedTimepicker";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {flowOptions} from "../FlowOptions";
import {Radio} from "antd";
import CustomButtonV2 from "../../../../../common/CustomButtonV2";
import Box from "../../../../../common/Layout/Box";
import VStack from "../../../../../common/Layout/VStack";
import HStack from "../../../../../common/Layout/HStack";
import {SINGLE_SESSION_EDIT_TYPE} from "../../../../../../services/ConstHelper";
import {useToast} from "react-native-toast-notifications";

const AvailabilitySlotSelection = (props) => {
    const { values, errors, setFieldValue, touched, target, disableDate } = props;
    const box = useSelector((state) => state.box.box);
    const flowName = useSelector((state) => state.stepper.name);
    const editType = useSelector((state) => state.stepper.editType);
    const lang = useSelector((state) => state.userSettings.lang);
    const error = useSelector(state => state.stepper.error)
    const [loading, setLoading] = useState(false);
    const [slots, setSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [isCurrentTargetSlot, setIsCurrentTargetSlot] = useState(false);
    const timeFormat = useMemo(() => box ? box.locations_box[0].time_format : null,[box])
    const mobile = isMobile
    const dispatch = useDispatch()
    const toast = useToast()

    useEffect(() => {
        generateSummary()
    }, [values, errors]);

    useEffect(() => {
        if(values.date && values.box_category_fk) {
            getAvailabilitySlots()
        } else {
            removeSlotSelection()
            setSlots([])
        }
    }, [values.date, values.box_category_fk]);

    useEffect(() => {
        if(editType && target) {
            if(target.date === values.date) {
                onCurrentTargetSlotSelected()
            } else {
                removeSlotSelection()
            }
        }
    }, [editType, values?.date]);

    useEffect(() => {
        if((values.spaces_id || values.coach_fk) && ((!editType && !values.repeatConfig?.repeat) || (editType === SINGLE_SESSION_EDIT_TYPE))) {
            let spaces = values.spaces_id ? [values.spaces_id] : []
            if(values.spaces_relation?.length) {
                const spaceRelation = values.spaces_relation?.reduce((acc, sr) => sr.id ? [...acc, sr.id] : acc, [])
                spaces = [...spaces, ...spaceRelation]
            }
            dispatch(updateTempSelection({
                spaces_id: spaces,
                date: values.date,
                start_time: values.time,
                end_time: values.end_time,
                schedule_id: values.scheduleTarget?.id ?? null,
                coach_id: values.coach_fk,
            }))
        } else {
            dispatch(updateTempSelection(null))
        }
    }, [values.spaces_id, values.repeatConfig?.repeat, values.date, values.time, values.end_time, values.spaces_relation, values.coach_fk, values.second_coach_fk]);


    useEffect(() => {
        sendDataEvent('add appointment pop up (with availability)- choose slot');
    }, []);

    useEffect(() => {
        if(error && error === 'slot-no-longer-available') {
            toast.show(t(error), {type: 'danger', duration: 3000})
            removeSlotSelection()
            getAvailabilitySlots()
        }
    }, [error]);

    const getAvailabilitySlots = async () => {
        setLoading(true)
        setSlots(null)
        const params = {
            availabilityId: target?.availability_id ?? target.id,
            date: values.date,
            locations_box_id: values.locations_box_fk,
            box_categories_id: values.box_category_fk,
            spaceAvailability: flowName === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY
        }
        const slotsRes = await fetchApi('availability/getAvailabilitySlots', 'post', params, false, true);
        setSlots(slotsRes)
        if(values.time && values.end_time) {
            const matchingSlot = slotsRes?.find(slot => (moment(slot.time, 'HH:mm').format(dbTimeFormat) === values.time) && (moment(slot.end_time, 'HH:mm').format(dbTimeFormat) === values.end_time))
            if (matchingSlot) onSlotSelected(matchingSlot)
            else {
                if(!editType) removeSlotSelection()
            }
        }
        setLoading(false)
    }

    const removeSlotSelection = () => {
        setSelectedSlot(null)
        setFieldValue('time', null)
        setFieldValue('end_time', null)
        setIsCurrentTargetSlot(false)
    }

    const onSlotSelected = (slot) => {
        setSelectedSlot(slot)
        setFieldValue('time', moment(slot.time, 'HH:mm').format(dbTimeFormat))
        setFieldValue('end_time', moment(slot.end_time, 'HH:mm').format(dbTimeFormat))
        setIsCurrentTargetSlot(false)
    }

    const onCurrentTargetSlotSelected = () => {
        setSelectedSlot(null)
        setFieldValue('time', moment(target.time, 'HH:mm').format(dbTimeFormat))
        setFieldValue('end_time', moment(target.end_time, 'HH:mm').format(dbTimeFormat))
        setIsCurrentTargetSlot(true)
    }

    const generateSummary = () => {
        const time = moment(values.time, dbTimeFormat).format(timeFormat);
        const endTime = moment(values.end_time, dbTimeFormat).format(timeFormat);
        const date = moment(values.date, dbDateFormat).format(`dddd, ${(lang?.language == 'Hebrew') ? 'DD MMM' : 'MMM DD'}, YYYY`)
        const daysAndTimes = `${date}, ${t('fromTime')} ${time} ${t('toTime')} ${endTime}`
        let summary;
        summary = t(`${flowName}-summary-one-time`, {daysAndTimes: daysAndTimes})
        dispatch(updateSummary(summary))
    }

    const onDateChange = (name, value) => {
        const date = moment(value).format(dbDateFormat)
        setFieldValue(name, date)
    }

    return (
        <VStack space={'1.5rem'}>
            {slots ?
                <>
                    <VStack space={'0.2rem'} width={mobile ? '100%' : '50%'}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('date')}</AppText>
                        <SharedTimepicker isDisabled={disableDate} type={'date'} value={moment(values.date, dbDateFormat)} onChange={(date) => onDateChange('date', date)} inputStyle={WebGlobalStyles.customInputNew}/>
                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.date && touched.date ? errors.date : ''}</AppText>
                    </VStack>
                    <VStack space={'0.2rem'} flex={1}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('time')}</AppText>
                        <Radio.Group name={'availability-slot-group'} value={isCurrentTargetSlot ? target : selectedSlot}>
                            <Box style={{display: 'grid', gridTemplateColumns: mobile ? '1fr' : 'repeat(4, 1fr)', gap: '0.6rem'}}>
                                {editType && target.date === values.date &&
                                    <CustomButtonV2 onClick={onCurrentTargetSlotSelected}
                                                    key={`payment-method-${target.time}-${target.end_time}`}
                                                    override={() =>
                                                        <HStack w={'100%'} space={'1rem'} p={'0.7rem'} border={`1px solid ${Colors.borderColor}`} borderRadius={4}>
                                                            <Radio value={target} size="sm" checked={isCurrentTargetSlot}/>
                                                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText}>{moment(target.time, 'HH:mm').format(timeFormat)} - {moment(target.end_time, 'HH:mm').format(timeFormat)}</AppText>
                                                        </HStack>}
                                    />
                                }
                                {slots?.map(slot => (
                                    <CustomButtonV2 onClick={() => onSlotSelected(slot)}
                                                    key={`payment-method-${slot.time}-${slot.end_time}`}
                                                    override={() =>
                                                        <HStack w={'100%'} space={'1rem'} p={'0.7rem'} border={`1px solid ${Colors.borderColor}`} borderRadius={4}>
                                                            <Radio value={slot} size="sm" checked={slot === selectedSlot}/>
                                                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText}>{moment(slot.time, 'HH:mm').format(timeFormat)} - {moment(slot.end_time, 'HH:mm').format(timeFormat)}</AppText>
                                                        </HStack>}
                                    />
                                ))}
                            </Box>
                            {slots.length === 0 && !loading &&
                                <HStack space={'0.5rem'} alignItems={'center'}>
                                    <FontAwesomeIcon fontSize={16} icon={solid('triangle-exclamation')}/>
                                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{!values.date || !values.box_category_fk ? t('select-type-and-date-warning') : t('no-slots-open')} </AppText>
                                </HStack>
                            }
                        </Radio.Group>
                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{((errors.time && touched.time) || (errors.end_time && touched.end_time)) ? t('select-slot-error') : ''}</AppText>
                    </VStack>
                </>
                :
                <ActivityIndicator/>
            }
        </VStack>
    );
};

export default AvailabilitySlotSelection;
